var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RosBagMessageType, RosBagPointCloudPlayerMessage, RosBagPointCloudPlayStateRequestMessage } from "../../../messages/rosbag/RosBagMessages";
import { scriptService } from "../services/ScriptService";
import { serverTimeService } from "../../rosbag/ServerTimeService";
import { AskOkMessage, BroadcastToPeerMessage } from "flavr-common";
export class ScriptRosBagPlayerControls {
    static togglePlay() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scriptService.context)
                return;
            const state = yield this.getLocalPlaybackState();
            if (state !== undefined) {
                if (state) {
                    const msg = new RosBagPointCloudPlayerMessage(RosBagMessageType.pause, serverTimeService.getServerTime());
                    scriptService.context.connection.sendMultiple([msg, new BroadcastToPeerMessage([msg])]);
                }
                else {
                    const msg = new RosBagPointCloudPlayerMessage(RosBagMessageType.play, serverTimeService.getServerTime());
                    scriptService.context.connection.sendMultiple([msg, new BroadcastToPeerMessage([msg])]);
                }
            }
        });
    }
    static previousTimeStep() {
        if (!scriptService.context)
            return;
        scriptService.context.connection.send(new RosBagPointCloudPlayerMessage(RosBagMessageType.previousTimeStep, undefined));
    }
    static nextTimeStep() {
        if (!scriptService.context)
            return;
        scriptService.context.connection.send(new RosBagPointCloudPlayerMessage(RosBagMessageType.nextTimeStep, undefined));
    }
    static getLocalPlaybackState() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scriptService.context)
                return undefined;
            const response = yield scriptService.context.connection.askByMessageType(new RosBagPointCloudPlayStateRequestMessage(), AskOkMessage);
            if (response) {
                return response.result;
            }
            else
                return undefined;
        });
    }
}
